import { Box, HStack, Text, VStack } from "@chakra-ui/react";
import ContinueBtn from "./ContinueBtn";
import { ReactElement } from "react";

type IProps = {
  title: ReactElement;
  subtTitle?: string;
  description?: string;
  color: string;
  value?: string;
  onClick: () => void;
};

const CompletionBoard = ({
  color,
  value,
  onClick,
  title,
  subtTitle,
  description,
}: IProps) => {
  return (
    <Box
      position={"relative"}
      height={{ base: "100vh", lg: "80vh" }}
      width={{ base: "100%", lg: "35rem" }}
      borderRadius={{ base: "none", lg: "base" }}
      mt={{ base: "none", lg: "5rem" }}
      mx={"auto"}
      bg={`linear-gradient(to bottom, ${color} 0%, rgba(255, 0, 0, 0) 70%)`}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="space-between"
      border={"1px solid"}
      borderColor={"neutral.900"}
      px="1.5rem"
    >
      {/* Center XP Section */}
      <Box
        position="absolute"
        top="40%"
        left="50%"
        transform="translate(-50%, -50%)"
        textAlign="center"
      >
        {title}
        {subtTitle && <Text>{subtTitle}</Text>}
      </Box>

      {/* Bottom Section */}
      <VStack
        position="absolute"
        bottom={{ base: "8rem", lg: "2rem" }}
        left="0"
        right="0"
        spacing={1}
        textAlign="center"
      >
        {value && (
          <>
            {" "}
            <HStack justifyContent="center" spacing={2}>
              <Text
                fontSize="4xl"
                color={color}
                mr={"-0.5rem"}
                fontWeight="bold"
              >
                +
              </Text>
              <Text fontSize="4xl" fontWeight="bold">
                {value}
              </Text>
            </HStack>
            <Text fontSize="lg" color="gray.500">
              TOTAL XP
            </Text>
          </>
        )}
        {description && <Text>{description}</Text>}
        <Box mt={"4rem"} display={{ base: "none", lg: "block" }}>
          <ContinueBtn onClick={onClick} />
        </Box>
      </VStack>

      {/* Continue Button */}
      <Box
        pb=".5rem"
        px="1.5rem"
        position="fixed"
        left={0}
        right={0}
        bottom="0.5rem"
        display={{ base: "block", lg: "none" }}
      >
        <ContinueBtn onClick={onClick} />
      </Box>
    </Box>
  );
};

export default CompletionBoard;
